export default __webpack_public_path__ + "static/media/gordijnen-2.2f346776.jpg";